import { render, staticRenderFns } from "./Home.tag-generator.vue?vue&type=template&id=3db80872&scoped=true&"
import script from "./Home.tag-generator.vue?vue&type=script&lang=js&"
export * from "./Home.tag-generator.vue?vue&type=script&lang=js&"
import style0 from "./Home.tag-generator.vue?vue&type=style&index=0&id=3db80872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db80872",
  null
  
)

export default component.exports